<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32.447" height="32.331" viewBox="0 0 32.447 32.331">
    <path class="a"
          :style="{fill:color, stroke:color}"
          d="M6.347,1.119A.408.408,0,0,0,5.97,1.4L1.128,10.828a.408.408,0,0,0,.034.52L16.678,32.78a.408.408,0,0,0,.661,0l15.5-21.39a.408.408,0,0,0,.036-.527L27.936,1.344c-.006-.012-.013-.023-.02-.035h0c-.008-.011-.015-.022-.024-.032h0a.328.328,0,0,0-.027-.03l0,0-.027-.024h0L27.8,1.193h0l-.033-.02,0,0a.418.418,0,0,0-.072-.029h0l-.038-.009h0a.448.448,0,0,0-.069-.007H6.419a.438.438,0,0,0-.071,0Zm.7.821h9.378l-4.807,8.254Zm10.723,0h9.115L22.42,10.177,17.774,1.94ZM6.372,2.4l4.581,8.273L2.131,10.66,6.372,2.4Zm21.193,0,4.3,8.3-8.8-.011L27.565,2.4Zm-10.465,0,4.669,8.278-9.483-.011L17.1,2.406ZM2.263,11.477l9.046.011,4.79,19.1L2.263,11.477Zm9.888.012,9.735.012L17.009,30.869l-4.858-19.38Zm10.575.013,9.014.011L17.921,30.586l4.8-19.084Z"
          transform="translate(-0.778 -0.869)"/>
  </svg>
</template>

<script>
export default {
  name: "SponsoringIcon",
  props: {
    color: String
  }
}
</script>

<style scoped>
.a {
  fill: #fff;
  stroke: #fff;
  stroke-width: 0.5px;
}
</style>
